import { FILE_TYPES } from "../../../../../shared/interfaces";
import ClaimService from "../../../../../shared/services/claim";
import DocumentsService from "../../../../../shared/services/documents";
import { downloadBase64Files, getError } from "../../../../../shared/utils";

export const getCompensationReceiptPDF = async (paymentOrderNumber: string): Promise<string | null> => {

    const filename = `ReciboIndemnizacion_`+paymentOrderNumber+`.pdf`;

    const ERROR_MSG_PDF = 'No se pudo obtener el documento "RECIBO DE INDEMNIZACIÓN".';
      
    const getOnTheFly = async (): Promise<string | null> => {
      
        try {
            const compensationReceiptDataResponse = await ClaimService.getCompensationReceiptData(paymentOrderNumber);
            if (!compensationReceiptDataResponse) {
              getError(ERROR_MSG_PDF)
              return null;
            }

            const compensationReceiptPdfResponse = await DocumentsService.getCompensationReceiptPdfOnTheFly(compensationReceiptDataResponse);
            const documento = compensationReceiptPdfResponse?.data?.base64;

            return documento ?? null;
          } catch (error) {
            getError(ERROR_MSG_PDF)
            return null;
          }
    };
  
    const base64 = await getOnTheFly();
  
    if (!base64) {
      throw new Error(ERROR_MSG_PDF);
    }
  
    downloadBase64Files(base64, filename, FILE_TYPES.PDF);
    return base64;

}

export const allowDownloadReceiptPayment = (numeroDeRecibo: any): boolean => {
    return String(numeroDeRecibo) !== '0';
  };
  
  